import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext.js';

const ComingSoonPage = ({ title }) => {
  const { isLight } = useTheme();

  return (
    <div className="min-h-screen pt-24 sm:pt-32 pb-16 sm:pb-24">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-8 md:px-12">

        {/* Back Navigation */}
        <Link
          to="/"
          className={`inline-flex items-center gap-2 text-xs sm:text-sm font-mono uppercase tracking-widest transition-colors mb-8 sm:mb-12 ${
            isLight ? 'text-gray-400 hover:text-primary' : 'text-white/50 hover:text-accent'
          }`}
        >
          <span className="material-symbols-outlined text-sm">arrow_back</span>
          Back to Home
        </Link>

        {/* Page Header */}
        <div className="mb-12 sm:mb-16">
          <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-6">
            <div className={`w-1.5 h-1.5 rounded-full ${
              isLight ? 'bg-primary shadow-[0_0_8px_#5e19e6]' : 'bg-accent shadow-[0_0_8px_#00f0ff]'
            }`} />
            <span className={`text-[9px] sm:text-[10px] font-mono uppercase tracking-widest ${
              isLight ? 'text-primary' : 'text-accent'
            }`}>
              Coming Soon
            </span>
          </div>

          <h1 className={`text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-light tracking-tight leading-[1.1] mb-6 ${
            isLight ? 'text-gray-900' : 'text-white'
          }`}>
            {title} <br />
            <span className={`font-bold text-transparent bg-clip-text bg-gradient-to-r ${
              isLight ? 'from-gray-900 via-gray-500 to-gray-300' : 'from-white via-white/70 to-white/20'
            }`}>
              Coming Soon.
            </span>
          </h1>

          <p className={`text-base sm:text-lg md:text-xl font-light leading-relaxed max-w-[65ch] ${
            isLight ? 'text-gray-500' : 'text-white/60'
          }`}>
            We're building something great. Stay tuned.
          </p>
        </div>

      </div>
    </div>
  );
};

export default ComingSoonPage;
